import React from "react";

const embroideryData = [
  {
    title: "Satin Stitch",
    image: "https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Satin_Stitch_Sharprint.jpg?width=300",
    alt: "Satin Stitch",
    description: `This is the most common embroidery stitch type and is used in the majority of lettering and design outlines. 
    In this example, the center of the "O" is filled using a fill stitch, and the edge is reinforced using a satin stitch. 
    The other text uses satin stitch for fill and outline. The blue "NOW" text is also satin stitch. This design is sewn over a screen print for a clever mixed media approach.`
  },
  {
    title: "Walking Stitch",
    image: "https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Walking_Stitch_Sharprint.jpg?width=300",
    alt: "Walking Stitch",
    description: `Also referred to as a running stitch, this dashed line style captures very small details. 
    Walking stitch is often used to replicate the look of hand sewing in retail designs.`
  },
  
  {
    title: "Fill Stitch",
    image: "https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Fill_Stitch_Sharprint.jpg?width=300",
    alt: "Fill Stitch",
    description: `Used to fill large areas of color or create an underlay foundation for complex designs. 
    On high pile garments like fleece, fill stitch prevents detail loss. This example shows fill stitch for most areas, satin stitch in the black swirl, and running stitch in the guitar fret detail.`
  }
];




export default function EmbroideryStitches() {
  return (
    <section className="page-center padding40tb">
      {/* Header */}
      <header style={{ textAlign: "center" }}>
        <h2>Types of Embroidery Stitches</h2>
      </header>

      {/* Intro */}
      <div className="text-center">
        <h3>3 Main Stitch Types</h3>
        <p>
          Each embroidery stitch serves a specific purpose. Depending on the design and fabric, we choose between three main stitch types to achieve the best results.
        </p>
        <p style={{ color: "#c43235", fontWeight: "bold" }}>
          Satin Stitch | Walking Stitch | Fill Stitch
        </p>
      </div>

      {/* Satin Stitch */}
      <div className="stitch-row">
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Satin_Stitch_Sharprint.jpg?width=300"
          alt="Satin Stitch"
          style={{ display: "block", margin: "0 auto", maxWidth: 300, width: "100%" }}
        />
        <div className="stitch-text" style={{ textAlign: "center" }}>
          <h4>Satin Stitch</h4>
          <p>
            The most common stitch, perfect for lettering and design outlines. Satin stitch can also fill areas in a design, giving smooth, polished results. Mixed with fill stitches, it can create bold, professional designs on any fabric.
          </p>
        </div>
      </div>

      {/* Walking Stitch */}
      <div className="stitch-row">
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Walking_Stitch_Sharprint.jpg?width=300"
          alt="Walking Stitch"
          style={{ display: "block", margin: "0 auto", maxWidth: 300, width: "100%" }}
        />
        <div className="stitch-text" style={{ textAlign: "center" }}>
          <h4>Walking Stitch</h4>
          <p>
            Also called a running stitch, it forms dashed lines ideal for fine details. This stitch mimics hand-sewing and adds a delicate, intricate touch to embroidery designs.
          </p>
        </div>
      </div>

      {/* Fill Stitch */}
      <div className="stitch-row">
        <img
          src="https://www.sharprint.com/hs-fs/hubfs/Sharprint/Website/Website_Pages/Embroidery/Embroidery_Stitch_Types/Embroidery_Stitch_Types_Fill_Stitch_Sharprint.jpg?width=300"
          alt="Fill Stitch"
          style={{ display: "block", margin: "0 auto", maxWidth: 300, width: "100%" }}
        />
        <div className="stitch-text" style={{ textAlign: "center" }}>
          <h4>Fill Stitch</h4>
          <p>
            Used to cover large areas with color or provide a foundation on delicate or textured fabrics. Fill stitches help maintain design detail and create solid, vibrant shapes for intricate embroidery.
          </p>
        </div>
      </div>

      {/* Stitch Count Info */}
      <div className="text-center" style={{ marginTop: 40 }}>
        <h3>How Are Stitch Counts Estimated?</h3>
        <p>
          Stitch counts depend on the design size and fabric type. For example, fleece garments may require higher stitch counts than cotton. Let us know your fabric to ensure accurate estimates. All quotes are subject to change until the final design is approved.
        </p>
      </div>
    </section>
  );
}
